import { ReactElement } from 'react';
import { InternalIconProps } from '../Icon/GenericIcon';

/**
 * String with <ComponentTag /> format
 * @param componentTag
 */
export const iconColorWarning = (
  iconContent: ReactElement<InternalIconProps>,
  componentTag: string
) => {
  if (iconContent?.props.color !== undefined) {
    console.warn(
      `Please remove "color" property from <Icon /> in ${componentTag} component. This property will be ignored, as we want to make sure that icon and text color in the button always match`
    );
  }
};
